<h2>EDIZIONE 2018</h2>
<div id="istruzioni">
	<h3>Istruzioni</h3>
	<ul>
		<li>Le Cryptowars2018 si svolgono nella settimana 15--21 Ottobre 2018.</li>
		<li>Inizio iscrizione dei team: 1 Ottobre 2018.</li>
		<li>Fine iscrizione dei team: 14 Ottobre 2018.</li>
		<li>Inizio gara: 15 Ottobre 2018 ore 14:00 (Milano).</li>
		<li>Fine gara: 21 Ottobre 2018 ore 14:00 (Milano).</li>
		<li>Premiazione a un evento De Cifris nel 2019 .</li>
		<li> Sono ammessi alla gara team composti da un massimo di 5 studenti.
			Con "studenti" intendiamo iscritti a: laurea, laurea triennale,
			laurea magistrale, dottorato di ricerca.</li>
		<li> Il team partecipante deve essere identificato con un unico indirizzo e-mail.
			Per iscriversi bisogna inviare una email a cryptowars2018&#64;gmail.com avente
			come oggetto la parola ISCRIZIONE.
			Nel messaggio di posta elettronica devono comparire il nome dei partecipanti,
			il nome del team e l'indirizzo e-mail di riferimento.</li>
		<li> Dal 15 al 21 Ottobre, i partecipanti alle CRYPTOWARS possono inviare al
			più TRE soluzioni al medesimo quesito. Viene tenuta in considerazione solo
			l'ultima e-mail ricevuta. </li>
		<li> Le soluzioni devono essere inviate all’indirizzo cryptowars2018&#64;gmail.com
			nel formato specificato nel file della challenge. Solitamente in formato .TXT </li>
		<!--<li> <a href="../../../../assets/attivita/cryptowars/Cryptowars2018Mat.zip">
				Materiale per <i>Math side</i></a></li>
		<li><a href="../../../../assets/attivita/cryptowars/Cryptowars2018Inf.zip">
				Materiale per <i>Computer Science side</i></a></li>
		-->
	</ul>
</div>
<hr>
<div id="FAQ">
	<h3>FAQ</h3>
	<ul>
		<li><i>Devo personalmente implementare del codice per risolvere i quesiti? </i><br>
			Non è richiesto di inviare il codice usato, quindi una via semplice è quella di
			cercare del codice già implementato. Resta il fatto che, siccome la gara ha soprattutto
			lo scopo di portare alla comprensione profonda di problemi crittografici, si consiglia
			di lavorare in maniera autonoma al proprio codice e alla sua ottimizzazione.<br>
		</li>
		<li><i>Devo pensare e implementare nuovi attacchi? </i><br>
			Non necessariamente. Esistono molti attacchi noti in letteratura, quindi cercane uno che
			ti sembra semplice da capire, implementalo e mandalo in esecuzione!</li>
	</ul>
</div>
<hr>
<div id="news">
	<h3>News</h3>
	<ul>
		<li>[22/10/2018] I risultati delle cryptowars 2018 sono stati pubblicati.</li>
		<li>[21/10/2018] Alle ore 14 abbiamo chiuso la challenge.</li>
		<li>[15/10/2018] Alle ore 14 abbiamo dato inizio all'evento.
			Le sfide sono state pubblicate. Buon divertimento!</li>
		<li>[15/10/2018] I team iscritti alla competizione sono 17:
			ACOP18, Codec, cryptogang, CryptoKillers, CryptoTeamUNITN,
			CryptoTL, CrypTrento, Deep lilla, GangOf4, La compagnia
			dell'anello, PAP-APP-Heroes, Pings with Things, Povo,
			pwnthem0le, Syntax Error, Teste Matte, x0R. </li>
		<li>[01/10/2018] Aperte le iscrizioni alla competizione CRYPTOWARS 2018. </li>
	</ul>
</div>
<hr>
<div id="classifica">
	<h3>Cryptowars 2018 - Classifica finale</h3>
	<p>Note:</p>
	<ul>
		<li>È possibile interagire con la legenda, cliccando sul colore opportuno per
			mostrare la classifica parziale delle due modalità;</li>
		<li>per completezza, sono stati riportati in colore più chiaro i
			risultati dei team che hanno consengnato oltre la data di scadenza.</li>
	</ul>
	<p>Ecco la classifica finale: </p>
	<table class="tg" align="center">
		<tr>
			<th class="tg-c3ow"></th>
			<th class="tg-7btt">MAT</th>
			<th class="tg-7btt">INF</th>
			<th class="tg-7btt">TOT</th>
		</tr>
		<tr>
			<td class="tg-uys7">#1 🥇</td>
			<td class="tg-0pky">Syntax Error</td>
			<td class="tg-0pky">Pings with Things</td>
			<td class="tg-0pky">CryptoTeamUNITN</td>
		</tr>
		<tr>
			<td class="tg-c3ow">#2 🥈</td>
			<td class="tg-0pky">CryptoTeamUNITN</td>
			<td class="tg-0pky">CryptoTeamUNITN</td>
			<td class="tg-0pky">pwnthem0le</td>
		</tr>
		<tr>
			<td class="tg-c3ow">#3 🥉</td>
			<td class="tg-0pky">pwnthem0le</td>
			<td class="tg-0pky">pwnthem0le</td>
			<td class="tg-0pky">Syntax Error</td>
		</tr>
	</table>
</div>
<hr>
<div id="statistiche">
	<h3>Statistiche</h3>
	<ul>
		<li><b>Partecipanti</b>: 64 (17 team)</li>
		<li><b>File ricevuti</b>: 48 [MAT] & 15 [INF]</li>
		<li><b>Esercizi risolti</b>: 24/32 [MAT] & 3/9 [INF]</li>
	</ul>
</div>